import { useRef } from 'react';
import { motion, useInView } from 'motion/react';
import { SmartLink } from '../smart-link/SmartLink';

export default function CardWrapper({
  colorIndex = false,
  className = '',
  children,
  theme = false,
  link = {},
  // theme = 'white',
}) {
  // console.log(colorIndex);

  const colors = ['yellow', 'blue', 'purple', 'orange', 'green'];
  const cardTheme =
    colorIndex !== false ? colors[colorIndex % colors.length] : 'white';

  const combinedClassName =
    // `${className} ${cardTheme ? `theme--${cardTheme}` : ''}`.trim();
    `${className}`.trim();

  const inner = (
    <div
      className={combinedClassName}
      style={{
        '--color-dynamicBackground':
          colorIndex !== false
            ? `var(--color-dynamic-${(colorIndex % 5) + 1})`
            : 'var(--color-milkwood)',
      }}
    >
      {children}
    </div>
  );

  if (link?.url) {
    return (
      <SmartLink
        href={link?.url}
        title={link?.title || undefined}
        className="cardWrapper-link"
      >
        {inner}
      </SmartLink>
    );
  }

  return inner;
}
